import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcherUI from './LanguageSwitcherUI';
import { getLanguageDirection } from '../../i18n/config';

interface LanguageSwitcherGuestProps {
  variant?: 'button' | 'compact';
  showLabel?: boolean;
}

/**
 * Language switcher for non-authenticated users (guest mode)
 * Only saves to localStorage, doesn't attempt database operations
 */
const LanguageSwitcherGuest: React.FC<LanguageSwitcherGuestProps> = (props) => {
  const { i18n } = useTranslation();
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';

  const handleLanguageChange = async (languageCode: string): Promise<void> => {
    // Change the language in i18n
    await i18n.changeLanguage(languageCode);
    
    // Save to localStorage only (no database operations for guests)
    if (typeof window !== 'undefined') {
      localStorage.setItem('i18nextLng', languageCode);
    }
  };

  return (
    <LanguageSwitcherUI
      {...props}
      onLanguageChange={handleLanguageChange}
    />
  );
};

export default LanguageSwitcherGuest; 
